<template lang="pug">

  v-tooltip(top :color="isDeletedFromAcompanhar ? 'rgba(180, 0, 0, 0.95)' : 'rgba(0, 0, 139, 0.95)'" :max-width="300")

    template(v-slot:activator="{ on, attrs }")

      .shiftCard(
        v-bind="attrs"
        v-on="on"
        :class="{ 'availableTurn': user.availableTurn && !isDeletedFromAcompanhar, 'closedTurn': user.closedTurn, 'miniReleased': isMiniReleased, 'deletedFromAcompanhar': isDeletedFromAcompanhar }"
        @click.stop.prevent="removeUserFromTurn"
      )

        img(:src="shiftImage" draggable="false" alt="").shiftCard__userPicture

        template(v-if="isDeletedFromAcompanhar")
          span.shiftCard__userName.shiftCard__userName--deleted Apagado

        template(v-else)
          span(v-if="user.availableTurn && !user.closedTurn" :class="{ 'availableTurn': user.availableTurn }").shiftCard__userName
            template(v-if="!day.isExpired")
              | Disponível
            template(v-else)
              | Vencido
          span(v-if="user.closedTurn && !user.availableTurn" :class="{ 'closedTurn': user.closedTurn }").shiftCard__userName Fechado
          span(v-if="user && user.userName && !user.availableTurn && !user.closedTurn" :title="user.userName").shiftCard__userName
            template(v-if="$vuetify.breakpoint.mdOnly")
              | {{ user.userName.replace(/(.{10})..+/, "$1&hellip;") }}
            template(v-else-if="$vuetify.breakpoint.lgOnly")
              | {{ user.userName.replace(/(.{17})..+/, "$1&hellip;") }}
            template(v-else)
              | {{ user.userName.replace(/(.{30})..+/, "$1&hellip;") }}

        b.removeUser &#10008;
        b.confirmedUser &#10004;

    span(style="vertical-align: middle")

      template(v-if="isDeletedFromAcompanhar")
        div
          b {{ deletedFromAcompanharTooltip }}
          div(v-if="deletedAssignedName" style="margin-top: 4px; opacity: 0.9;")
            | Plantonista:&nbsp;
            b {{ deletedAssignedName }}

      template(v-else)
        b(v-if="user.availableTurn && !user.closedTurn" :class="{ 'availableTurn': user.availableTurn }")
          template(v-if="!day.isExpired")
            | Disponível
          template(v-else)
            | Vencido
        b(v-if="user.closedTurn && !user.availableTurn" :class="{ 'closedTurn': user.closedTurn }")
          | Fechado
        b(v-if="user && user.userName && !user.availableTurn && !user.closedTurn" :title="user.userName")
          | {{ user.userName || 'Sem nome' }}

</template>

<script>
  import moment from 'moment'

  export default {
    name: 'SosEditShiftCard',

    props: {
      user: { type: Object, required: true },
      shiftImage: { type: String, required: true },
      turnID: { type: String, required: true },
      day: { type: Object, required: true },
      userIndex: { type: Number, required: true },
      week: { type: Object, required: true },
      scaleTurns: { type: Array, required: true },
    },

    computed: {
      isDeletedFromAcompanhar() {
        return !!this.user._deletedFromAcompanhar
      },

      deletedFromAcompanharTooltip() {
        const info = this.user._deletedFromAcompanhar
        if (!info) return ''

        const name = info.deletedByName || 'Gestor'
        const ts = info.deletedAt

        if (!ts) return `Apagado por ${name}`

        const date = moment(ts).format('DD/MM/YYYY')
        const time = moment(ts).format('HH:mm')

        return `Apagado por ${name} em ${date} às ${time}`
      },

      deletedAssignedName() {
        return this.user._deletedFromAcompanhar?.assignedUserName || ''
      },

      isMiniReleased() {
        if (this.scaleTurns.length === 0) return false

        const dayFmtWzero = this.day.dayFmtWzero
        return this.scaleTurns.some(turn => {
          const diaComUsuarios = turn.plantoes && turn.plantoes[dayFmtWzero]
          return diaComUsuarios &&
                  diaComUsuarios.confirmedDutys === true &&
                  diaComUsuarios.miniReleased &&
                  diaComUsuarios.miniReleased.released === true
        })
      },
    },

    methods: {
      removeUserFromTurn () {
        if (this.isDeletedFromAcompanhar) return
        this.$emit('removeUserFromTurn', this.turnID, this.day, this.user.turnUserID, this.userIndex, this.week)
      },
    },
  }

</script>

<style lang="scss">

  .scaleTurnDay.scaleTurnDay--expired
  {
    .shiftCard {
      opacity: 0.7;
      // filter: grayscale(0.5);
    }

    .confirmedUser {
      color: #333333;
    }

    .removeUser {
      color: #333333;
    }

    .shiftCard__userPicture {
      opacity: 0.8;
      filter: grayscale(1);
    }
  }

  .calendarWeek.confirmedDutys
  {
    .confirmedUser {
      display: block;
    }

    .removeUser {
      display: none;
    }
  }

  .calendarWeek.confirmedDutys
  {
    .removeUser {
      display: none;
    }

    .confirmedUser {
      display: block;
    }
  }

  // Estilo para dias mini disparados
  .shiftCard.miniReleased
  {
    .confirmedUser {
      display: block;
    }

    .removeUser {
      display: none;
    }
  }

</style>

<style lang="scss" scoped>

  //
  //
  //

  .shiftCard
  {
    position: relative;

    cursor: pointer;
    user-select: none;

    margin-bottom: 3px;
    border-radius: 30px;
    min-height: 43px;
    box-shadow: inset 0px 0px 10px 1px rgba(0, 0, 0, 0.1);
    background-color: #fdab3d;

    color: #FFFFFF;
    font-size: 13px;
    font-weight: 500;
    text-align: left;
    text-decoration: none;

    &.availableTurn {
      background-color: #00cb72;
    }

    &.closedTurn {
      background-color: red;
    }

    &.deletedFromAcompanhar {
      background-color: #b71c1c;
      opacity: 0.85;
      text-decoration: line-through;
      cursor: default;

      .removeUser {
        display: none;
      }
    }
  }

  //
  //
  //

  .shiftCard__userName {
    position: absolute;
    top: 50%;

    display: inline-block;
    width: 100%;
    padding-left: 50px;
    padding-right: 30px;
    transform: translateY(-50%);
    overflow: hidden; // Reticências

    line-height: 2;
    text-overflow: ellipsis; // Reticências
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.6);
    white-space: nowrap; // Reticências
  }

  //
  //
  //

  .shiftCard__userPicture
  {
    position: absolute;
    top: 0;
    left: 3px;
    bottom: 0;

    width: 37px;
    height: 37px;
    margin: auto 0;
    border-radius: 50%;
  }

  //
  //
  //

  .confirmedUser,
  .removeUser {
    position: absolute;
    right: 10px;
    top: 50%;

    transform: translateY(-50%);
  }

  .confirmedUser {
    display: none;
    color: greenyellow;
  }

  .removeUser {
    color: indianred;
  }

  .shiftCard__userName--deleted {
    text-decoration: none;
    font-weight: 700;
    letter-spacing: 0.03em;
  }

</style>
